"use strict";

// Copyright 2012-2022 The MathWorks, Inc.
define(['mw-log/Log'], function (Log) {
  var absoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
  var ALLOWED_LOCAL_DOMAINS = ['localhost', '127.0.0.1', '[::1]'];
  return {
    /**
     * Motivation: The reason we need to do this is because every client which uses connector to get a URL to a resource or an app gets back
     * a localhost based URL. However, in MATLAB Online and other remote environemnts localhost based url cannot be used to acces remote resources.
     * This API is responsible for converting the localhost based URL into a Remote Worker URL which can be used to talk to remote resource.
     */

    /**
     * JSDoc
     * Returns absolute url that can be used to access resource on worker.
     * Also adds query parameters to url
     * @param {String} url - Absolute localhost based url or path to resource being accessed
     * @param {Object} opts - This object contains metadata to be used by the API:
     * opts.host: Endpoint to the worker
     * opts.sessionId: Session ID for the current MO session
     * opts.routingKey: IP Adddress and port number to reach the MATLAB on opts.host
     */
    createWorkerRoutingHostUrl: function createWorkerRoutingHostUrl(url, opts) {
      var absRemoteUrl = url;
      var remoteHost = '';
      var localhostUrl = '';
      var host = opts.host;
      var sessionId = opts.sessionId;
      var routingKey = opts.routingKey; // flag to see if we need to add query parameters

      var shouldAddQueryParams = true;

      try {
        // Get the remote origin
        remoteHost = new URL(host); // Check if absolute url, then check for local host

        if (this.isAbsoluteUrl(url)) {
          // convert to URL object to see if localhost url
          localhostUrl = new URL(url); // Checking valid origin prevents issues when url is malformed like invalid protocol: https://foo.com

          if (localhostUrl.origin && ALLOWED_LOCAL_DOMAINS.includes(localhostUrl.hostname)) {
            var localhostPath = localhostUrl.pathname; // Use the remote URL as base url (context root gets ignored when used as base, so this avoids duplication)

            absRemoteUrl = new URL(localhostPath, remoteHost).href; // Add all the search strings back

            absRemoteUrl = absRemoteUrl + localhostUrl.search;
          } else if (localhostUrl.origin && localhostUrl.hostname !== remoteHost.hostname) {
            // it's an absolute URL but not a local URL or a remote worker URL so we don't need to add query params
            shouldAddQueryParams = false;
          }
        } else {
          // Remove starting / if present
          if (url && url.startsWith('/')) {
            absRemoteUrl = remoteHost + url.substr(1, url.length);
          } else {
            absRemoteUrl = remoteHost + url;
          }
        } // Add the mandatory mre query parameter.

        /**
         * Note: Ideally this can be done by using URL contrsuctor and appending query params, but this will encode/escape the query parameters
         * And am not certain that all teams actually decode the values before they use them.
         * So using the same implementation from IframeContainerConnectionUtil.
         *
         * //TODO: In the future look to update code below to be something like this:
         * absRemoteUrl = new URL(absRemoteUrl);
         * absRemoteUrl.searchParams.append("mre", remoteHost);
         */
        // Check if query parameters should be added or not


        if (!shouldAddQueryParams) {
          return absRemoteUrl;
        }

        absRemoteUrl += (absRemoteUrl.indexOf('?') >= 0 ? '&' : '?') + 'mre=' + encodeURIComponent(remoteHost); // Add additional query parameters if present

        if (routingKey && sessionId) {
          // Do not URI Encode Routing key -
          // connector doesn't know what to do with the encoded ":" (colon)
          // this is probably a bug (g2671961)
          absRemoteUrl += '&routingkey=' + routingKey + '&computeToken=' + encodeURIComponent(sessionId);
        }

        return absRemoteUrl;
      } catch (error) {
        Log.error('Input URL is malformed');
      }

      return absRemoteUrl;
    },

    /**
     * JSDoc
     * Returns whether a URL is absolute or relative.
     * @param {String} url - Relative or absolute URL
     */
    isAbsoluteUrl: function isAbsoluteUrl(url) {
      if (absoluteUrlRegex.test(url)) {
        return true;
      }

      return false;
    }
  };
});
//# sourceMappingURL=RemoteUrlUtils.js.map
